import type { CustomerState } from "@polar-sh/sdk/models/components/customerstate.js"
import type { CustomerStateSubscription } from "@polar-sh/sdk/models/components/customerstatesubscription.js"
import type { Product } from "@polar-sh/sdk/models/components/product.js"
import type { ProductPriceFixed } from "@polar-sh/sdk/models/components/productpricefixed.js"
import type { TProductMetadata } from "./models"

export type ProductWithMetadata = Product & {
  metadata: TProductMetadata
  fixedPrice: ProductPriceFixed
}

export type OrgCustomerState = {
  customerState: CustomerState | null
  activeSubscription: CustomerStateSubscription | null
  activeProduct: ProductWithMetadata | null
}

// Plan Types/Levels = Entitlements
export enum Entitlement {
  PRO = "pro",
  ULTRA = "ultra",
  ENTERPRISE = "enterprise",
}

export enum CancellationReason {
  TOO_EXPENSIVE = "too_expensive",
  MISSING_FEATURES = "missing_features",
  SWITCHED_SERVICE = "switched_service",
  UNUSED = "unused",
  CUSTOMER_SERVICE = "customer_service",
  LOW_QUALITY = "low_quality",
  TOO_COMPLEX = "too_complex",
  OTHER = "other",
}

export enum RefundReason {
  DUPLICATE = "duplicate",
  FRAUDULENT = "fraudulent",
  CUSTOMER_REQUEST = "customer_request",
  SERVICE_DISRUPTION = "service_disruption",
  SATISFACTION_GUARANTEE = "satisfaction_guarantee",
  OTHER = "other",
}
